module.exports = __webpack_public_path__ + "img/report_pic2.53d8b6c0.png";